<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Revendedores</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie revendedores da plataforma</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Consulte dados principais, saldo de creditos e status de split dos revendedores cadastrados.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Total</p>
        <strong class="text-lg">{{ totalRevendedores }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Com split</p>
        <strong class="text-lg">{{ totalSplitAtivos }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <p class="text-sm text-dark-color/70">Acompanhe a lista completa e inicie novos cadastros quando precisar.</p>
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
        (click)="openModalCreateNewRevendedor()">
        <mat-icon>add</mat-icon>
        Novo revendedor
      </button>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Email</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Telefone</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Vl Canal</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Creditos</th>
            <th class="px-4 py-3 text-center font-semibold text-dark-color">Split</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Acoes</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr *ngFor="let revendedor of listRevendedores" class="transition hover:bg-light-color/60">
            <td class="px-4 py-3 text-dark-color">{{ revendedor.nome }}</td>
            <td class="px-4 py-3 text-dark-color">{{ revendedor.email }}</td>
            <td class="px-4 py-3 text-dark-color">{{ revendedor.telefone }}</td>
            <td class="px-4 py-3 text-right text-dark-color">R$ {{ revendedor.price }}</td>
            <td class="px-4 py-3 text-right text-dark-color">{{ revendedor.wallet_credits }}</td>
            <td class="px-4 py-3 text-center">
              <span class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-light-color/70 text-dark-color">
                <mat-icon class="text-base">{{ revendedor.split ? 'check' : 'close' }}</mat-icon>
              </span>
            </td>
            <td class="px-4 py-3 text-right">
              <div class="flex justify-end gap-2">
                <button
                  type="button"
                  class="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  title="Editar">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  type="button"
                  class="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  title="Inativar Revendedor">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="listRevendedores.length === 0">
            <td colspan="7" class="px-4 py-6 text-center text-dark-color/70">
              Nenhum revendedor encontrado.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<ng-container *ngIf="isModalCreateNewRevendedor">
  <div class="fixed inset-0 z-30 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-6xl max-h-[calc(100vh-48px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Cadastro</p>
          <h3 class="text-lg font-semibold text-dark-color">Cadastrar revendedor WL</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="closeModalCreateNewRevendedor()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3" [formGroup]="formRegisterRevendedor" (ngSubmit)="cadastrarRevendedor()" novalidate>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="usuario">
          <span>Usuario</span>
          <input
            type="text"
            id="usuario"
            name="usuario"
            required
            formControlName="username"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="senha">
          <span>Senha</span>
          <input
            type="password"
            id="senha"
            name="senha"
            required
            formControlName="password"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color md:col-span-2 xl:col-span-3" for="revendedor">
          <span>Revendedor</span>
          <input
            type="text"
            id="revendedor"
            name="revendedor"
            required
            formControlName="revendedor"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="nome">
          <span>Nome</span>
          <input
            type="text"
            id="nome"
            name="nome"
            required
            formControlName="nome"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="type">
          <span>Tipo</span>
          <select
            id="type"
            name="type"
            required
            formControlName="type"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
            <option value="individual">Individual</option>
            <option value="company">Company</option>
          </select>
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="email">
          <span>E-mail</span>
          <input
            type="email"
            id="email"
            name="email"
            required
            formControlName="email"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="documenttype">
          <span>Tipo de Documento</span>
          <select
            id="documenttype"
            name="documenttype"
            required
            formControlName="documenttype"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
            <option value="CPF">CPF</option>
            <option value="CNPJ">CNPJ</option>
          </select>
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="document">
          <span>Documento</span>
          <input
            type="text"
            id="document"
            name="document"
            required
            formControlName="document"
            (keyup)="formatarDocument()"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="telefone">
          <span>Telefone</span>
          <input
            type="tel"
            id="telefone"
            name="telefone"
            required
            formControlName="telefone"
            (keyup)="formatarTelefone()"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="price">
          <span>Preco (R$)</span>
          <input
            type="number"
            id="price"
            name="price"
            min="0"
            required
            formControlName="price"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="split">
          <span>Split</span>
          <select
            id="split"
            name="split"
            required
            formControlName="split"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
            <option value="true">Verdadeiro</option>
            <option value="false">Falso</option>
          </select>
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color md:col-span-2 xl:col-span-3" for="hostSite">
          <span>Host do Site</span>
          <input
            type="url"
            id="hostSite"
            name="hostSite"
            required
            formControlName="hostSite"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>
        <label class="flex flex-col gap-2 text-sm text-dark-color md:col-span-2 xl:col-span-3" for="stylesHost">
          <span>Styles Host</span>
          <textarea
            id="stylesHost"
            name="stylesHost"
            rows="4"
            formControlName="stylesHost"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color resize-none"></textarea>
        </label>
        <div class="flex flex-col justify-end gap-2 sm:flex-row md:col-span-2 xl:col-span-3">
          <button
            type="button"
            class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color"
            (click)="closeModalCreateNewRevendedor()">
            Cancelar
          </button>
          <button
            type="submit"
            class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Cadastrar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
